// src/services/contactApi.js

// ------------------------------
// SAFE BASE URL HANDLING
// ------------------------------

// Priority 1: Production env REACT_APP_API_URL1
// Priority 2: REACT_APP_API_URL (if exists)
// Priority 3: Localhost fallback
const BASE =
  (process.env.REACT_APP_API_URL1 ||
    process.env.REACT_APP_API_URL ||
    "http://localhost:5001").replace(/\/+$/, "");

// Append /api/v1
const API_BASE_URL = `${BASE}/api/v1`;


// ------------------------------
// SUBMIT CONTACT FORM
// ------------------------------
export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/contact/submit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName: formData.firstName,
        lastName: formData.lastName || "",
        email: formData.email,          // ✅ REQUIRED
        phone: formData.phone,          // ✅ REQUIRED
        subject: formData.subject || "Coaching Lead",
        country: formData.country || "India",
        message: formData.message || "",
        class: formData.class,          // ✅ ADD THIS
        city: formData.city,            // ✅ ADD THIS
      }),
    });

    const text = await response.text();

    if (!response.ok) {
      throw new Error(text || "Failed to submit contact form");
    }

    return JSON.parse(text);
  } catch (error) {
    console.error("Contact Form Submission Error:", error);
    throw error;
  }
};



// ------------------------------
// ADMIN: GET CONTACTS
// ------------------------------
export const getAllContacts = async (token, status = "") => {
  try {
    const url = new URL(`${API_BASE_URL}/admin/contacts`);
    if (status) url.searchParams.append("status", status);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const text = await response.text();
    if (!response.ok) throw new Error(text || "Failed to fetch contacts");

    return JSON.parse(text);
  } catch (error) {
    console.error("Fetch Contacts Error:", error);
    throw error;
  }
};


// ------------------------------
// ADMIN: GET BY ID
// ------------------------------
export const getContactById = async (token, contactId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/contacts/${contactId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const text = await response.text();
    if (!response.ok) throw new Error(text || "Failed to fetch contact");

    return JSON.parse(text);
  } catch (error) {
    console.error("Fetch Contact Error:", error);
    throw error;
  }
};


// ------------------------------
// ADMIN: UPDATE STATUS
// ------------------------------
export const updateContactStatus = async (token, contactId, status) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/admin/contacts/${contactId}/status`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      }
    );

    const text = await response.text();
    if (!response.ok)
      throw new Error(text || "Failed to update contact status");

    return JSON.parse(text);
  } catch (error) {
    console.error("Update Contact Status Error:", error);
    throw error;
  }
};


// ------------------------------
// ADMIN: DELETE
// ------------------------------
export const deleteContact = async (token, contactId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/contacts/${contactId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const text = await response.text();
    if (!response.ok)
      throw new Error(text || "Failed to delete contact");

    return JSON.parse(text);
  } catch (error) {
    console.error("Delete Contact Error:", error);
    throw error;
  }
};


// ------------------------------
// ADMIN: STATS
// ------------------------------
export const getContactStats = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/contacts`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const text = await response.text();
    if (!response.ok)
      throw new Error(text || "Failed to fetch stats");

    const data = JSON.parse(text);

    const stats = {
      total: data.count || 0,
      pending: 0,
      contacted: 0,
      resolved: 0,
    };

    if (data.data && Array.isArray(data.data)) {
      data.data.forEach((contact) => {
        if (contact.status === "pending") stats.pending++;
        if (contact.status === "contacted") stats.contacted++;
        if (contact.status === "resolved") stats.resolved++;
      });
    }

    return { success: true, stats };
  } catch (error) {
    console.error("Fetch Contact Stats Error:", error);
    throw error;
  }
};


export default {
  submitContactForm,
  getAllContacts,
  getContactById,
  updateContactStatus,
  deleteContact,
  getContactStats,
};
